import axiosService from '@/services/axios/axios.service';

interface CreateTicketPayload {
  uid: string;
  urlImages: string[];
  reason: string;
  includeScreenshots?: boolean;
  includeTotalKeyboard?: boolean;
  includeTotalMouse?: boolean;
  includeKeySequence?: boolean;
  totalKeyboard?: number;
  totalMouse?: number;
  keySequence?: string;
}

const createTicket = async (payload: CreateTicketPayload): Promise<void> => {
  const response = await axiosService.post('/ticket/create', payload);
  return response.data;
};

export { createTicket };

